export const mutations = {
  setOrder: (state, order) => {
    state.order_list = order;
  },
  setProfile: (state, profile) => {
    state.profile = profile;
  },

  setIsAuthenticated: (state, status) => {
    state.IsAuthenticated = status;
  },

  setArtists: (state, artist_profiles) => {
    state.artists = artist_profiles;
  },

  setFeaturedArtistsProfile: (state, artist_profiles) => {
    state.featured_artists = artist_profiles;
  },

  setArt: (state, art) => {
    state.art = art;
  },
  setExploreArt: (state, json_data) => {
    state.explore_art = json_data;
  },

  setExhibitionList: (state, json_data) => {
    state.exhibition_list = json_data;
  },

  setArtistProfile: (state, artist_profile) => {
    state.artistProfile = artist_profile;
  },

  appendToWishList: (state, wishlist_item) => {
    state.wishList.push(wishlist_item);
  },

  setWishList: (state, wishlist) => {
    state.wishList = wishlist;
  },

  deleteFromWishList: (state, product_id) => {
    let required_wished_product = state.wishList.filter(
      (product) => product.wish_product.id == product_id
    )[0];

    let required_wished_product_index = state.wishList.indexOf(
      required_wished_product
    );

    state.wishList.splice(required_wished_product_index, 1);
  },

  setArtistProducts: (state, artistProducts) => {
    state.artistProducts = artistProducts;
  },

  appendArtistProducts: (state, artistProducts) => {
    for (let product of artistProducts) {
      state.artistProducts.push(product);
    }
  },

  setHomePageContent: (state, homePageContent) => {
    state.homePageContent = homePageContent;
  },

  setMostSold: (state, most_sold) => {
    state.mostSoldArt = most_sold;
  },

  setRelatedProducts: (state, related_products) => {
    // state.realtedProducts.push(json_data)

    for (let product of related_products) {
      state.realtedProducts.push(product);
    }
  },

  setCategoryInfo: (state, category_info) => {
    state.categoryInfo.push(category_info);
  },

  setSubCategoryProducts: (state, sub_category_products) => {
    for (let product of sub_category_products) {
      state.subCategoryProducts.push(product);
    }
  },

  setCategories: (state, categories) => {
    state.categories = categories;
  },

  setArtstoriesList: (state, art_stories_list_json) => {
    state.art_stories_list = art_stories_list_json;
  },

  setArtStory: (state, art_story) => {
    state.art_story = art_story;
  },

  setFeaturedArtstoriesList: (state, featured_art_stories_list) => {
    state.featured_art_stories_list = featured_art_stories_list;
  },

  setCartList: (state, cart_list_json) => {
    state.cart_list = cart_list_json;
  },

  setAddressList: (state, address_list) => {
    state.address_list = address_list;
  },

  addAddressList: (state, address) => {
    state.address_list.unshift(address);
  },

  deleteAddressFromList: (state, address_id) => {
    let address_index = state.address_list.findIndex(
      (element) => element.id == address_id
    );
    state.address_list.splice(address_index, 1);
  },
};
